// ワークフロー用ユーザ種別
export enum ReceptionUserKinds {
  None = 0,
  Admin = 1, // 管理者
  Creator = 2, // 記載者
}
